import type { SVGProps } from "react";

type LogoProps = {
  inverted?: boolean;
  size?: number;
} & Omit<SVGProps<SVGSVGElement>, "viewBox">;

/**
 * Crewvas mark — "The Framing Bracket & Node".
 *
 * A bold square bracket in the shape of a C (Command Navy) stands for the
 * frame the teacher draws around the lesson. Inside it three nodes line up
 * toward the bracket's opening, the leading one in Sync Blue: the crew
 * falling in behind the teacher's cue.
 */
export const Logo = ({ inverted = false, size = 22, ...rest }: LogoProps) => {
  const frame = inverted ? "#ffffff" : "#0F172A";
  const lead = inverted ? "#ffffff" : "#2563EB";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      <g fill={frame}>
        <rect x="2" y="2" width="5.5" height="24" rx="2.5" />
        <rect x="2" y="2" width="17" height="5.5" rx="2.5" />
        <rect x="2" y="20.5" width="17" height="5.5" rx="2.5" />
      </g>
      <circle cx="12" cy="14" r="2.2" fill={frame} opacity="0.35" />
      <circle cx="18.5" cy="14" r="2.2" fill={frame} opacity="0.6" />
      <circle cx="25" cy="14" r="2.6" fill={lead} />
    </svg>
  );
};
